export default "__VITE_ASSET__CXBlGmYP__"